export default __webpack_public_path__ + "static/media/BbpsLogo.54cc3299.png";